import type { FPlusVariableScopeOutput } from '@festina/configuration-general-types/configuration'
import { useTranslate } from '@festina-life/ui/hooks'
import { paperStyles } from '@festina-life/ui/libs'
import cx from 'classnames'
import type { PropsWithChildren } from 'react'

import { useFPlusScopeFilterValue } from '../../context/fPlusScopeFilterValueContext'
import { MarkdownViewer } from '../markdownviewer/MarkdownViewer'
import { HoverMenuList } from './HoverMenuList'

export type FPlusEnvironmentScopeProps = PropsWithChildren & {
  variables: FPlusVariableScopeOutput[]
}

export const FPlusVariableScopeList = ({
  variables,
  children,
}: FPlusEnvironmentScopeProps) => {
  const translate = useTranslate()
  const { filterValue } = useFPlusScopeFilterValue()

  return (
    <HoverMenuList
      filterValue={filterValue}
      elements={variables.sort((a, b) =>
        a.propertyName!.localeCompare(b.propertyName!),
      )}
      renderLabel={(variable) => (
        <div className="flex w-full">
          <MarkdownViewer className="grow text-left text-base">
            {`\`${variable.propertyName}\``}
          </MarkdownViewer>
          <p className="italic text-gray-300">{variable.typeName}</p>
        </div>
      )}
      renderHover={(variable) => (
        <div
          className={cx(
            'h-full w-[40em] overflow-auto',
            paperStyles({ isFaded: true }),
          )}
        >
          <p className="text-center text-lg">
            {translate(
              'templateViewer.sidebar.scopePopover.propertyDocumentation',
            )}
          </p>
          <MarkdownViewer shouldTransformLinksToDocSite className="text-left">
            {variable.propertyDocumentation ??
              translate(
                'templateViewer.sidebar.scopePopover.noPropertyDocumentation',
              )}
          </MarkdownViewer>
          <p className="text-center text-lg">
            {translate('templateViewer.sidebar.scopePopover.typeDocumentation')}
          </p>
          <MarkdownViewer shouldTransformLinksToDocSite className="text-left">
            {variable.typeDocumentation ??
              translate(
                'templateViewer.sidebar.scopePopover.noTypeDocumentation',
              )}
          </MarkdownViewer>
        </div>
      )}
    >
      {children}
    </HoverMenuList>
  )
}
